/**
 * This is a utility module also used on the frontend side
 * Please do not insert any specific backend configuration
*/
const {VARIABLE_TO_URL_PARAMETERS} = require('./urlParametersMap');

module.exports = function(search_query) {

  if (! search_query) {
    return null;
  }

  if (typeof search_query != 'object') {
    console.error('makeURLFromSearchQuery: invalid input');
    return null;
  }

  let params = {
    q: search_query.query,
  };

  for (let cat in search_query.cats) {
    // No need to add cat if it is empty
    if (search_query.cats[cat]
      && Object.keys(search_query.cats[cat]).length > 0) {
      params[cat] = JSON.stringify(search_query.cats[cat]);
    }
  }

  // Put date_from/to only if they are non-null
  if (search_query.date_from != null) {
    params.date_from = search_query.date_from;
  }
  if (search_query.date_to != null) {
    params.date_to = search_query.date_to;
  }
  if (search_query.date_exact != null) {
    params.date_exact = search_query.date_exact;
  }

  if (search_query.explicit_law_matches_text === true && search_query.law_article_id != null) {
    params.law_article_id = search_query.law_article_id;
  }

  if (search_query.filter_on_specific_article_version === true && search_query.law_article_id != null) {
    params.filter_on_specific_article_version = search_query.filter_on_specific_article_version;
    params.law_article_id = search_query.law_article_id;
  }

  // Since default is chrono=false, do not put it in that case
  if (search_query.chrono != null && search_query.chrono !== false) {
    params.chrono = search_query.chrono;
  }

  // Since default is chrono_inverted=false, do not put it in that case
  if (search_query.chrono_inverted != null && search_query.chrono_inverted !== false) {
    params.chrono_inverted = search_query.chrono_inverted;
  }

  // Since default is sort_nbr_commentaire=false, do not put it in that case
  if (search_query.sort_nbr_commentaire != null && search_query.sort_nbr_commentaire !== false) {
    params.sort_nbr_commentaire = search_query.sort_nbr_commentaire;
  }

  // Since default is exclude_moyens=false, do not put it in that case
  if (search_query.exclude_moyens != null && search_query.exclude_moyens !== false) {
    params.exclude_moyens = search_query.exclude_moyens;
  }

  if (search_query.only_top_results === false) {
    params.only_top_results = search_query.only_top_results;
  }

  if (search_query.original_query_key != null) {
    params.original_query_key = search_query.original_query_key;
  }

  if (search_query['enterprise_id'] != null) {
    params[VARIABLE_TO_URL_PARAMETERS['enterprise_id']] = search_query['enterprise_id'];
  }

  if (search_query['lawyer_id'] != null) {
    params[VARIABLE_TO_URL_PARAMETERS['lawyer_id']] = search_query['lawyer_id'];
  }

  if (search_query['law_office_id'] != null) {
    params[VARIABLE_TO_URL_PARAMETERS['law_office_id']] = search_query['law_office_id'];
  }

  if (search_query.type != null && search_query.type !== 'arret') {
    params.type = search_query.type;
  }

  if (search_query.selected_keywords
    && search_query.selected_keywords.length > 0
    && search_query.type === 'arret') {
    params.selected_keywords = JSON.stringify(search_query.selected_keywords);
  }

  for (let field of ['party', 'other_party']) {
    if (search_query[field]) {
      params[field] = JSON.stringify(search_query[field]);
    }
  }

  if (search_query.disable_autocorrect === true) {
    params.disable_autocorrect = search_query.disable_autocorrect; 
  }

  return params;
};
